<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Show Case</h5>
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" align="right" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <b-dropdown
            :disabled="selected.length === 0"
            id="dropdown-1"
            text="Action"
            :variant="selected.length === 0 ? 'primary':'warning'"
            class="m-md-2"
          >
            <b-dropdown-item @click="submitStatus('publish')" href="#">Publish</b-dropdown-item>
            <b-dropdown-item @click="submitStatus('archive')" href="#">Archive</b-dropdown-item>
          </b-dropdown>
          <router-link :to="{name: 'createShowCase'}">
            <b-button variant="primary">
              <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        show-empty
        hover
        ref="selectableTable"
        selectable
        :select-mode="selectMode"
        @row-selected="onRowSelected"
        responsive="sm"
        :busy="loading"
        :items="items"
        :fields="key"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:head(selected)="data">
          <span class="text-info">
            <b-form-checkbox
              v-model="allSelected"
              :indeterminate="indeterminate"
              aria-describedby="items"
              aria-controls="items"
              @change="toggleAll"
              :value="data"
            ></b-form-checkbox>
          </span>
        </template>
        <template v-slot:cell(selected)="{ rowSelected}">
          <template v-if="rowSelected">
            <span aria-hidden="true">
              <b-form-checkbox
                id="checkbox-1"
                v-model="selected_field_true"
                name="checkbox-1"
                value="true"
                class="pointer-off"
                unchecked-value="false"
              ></b-form-checkbox>
            </span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">
              <b-form-checkbox
                id="checkbox-1"
                v-model="selected_field_false"
                name="checkbox-1"
                value="true"
                class="pointer-off"
                unchecked-value="false"
              ></b-form-checkbox>
            </span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <template v-slot:cell(publish_date)="{ value, item }">
          <div>
            {{item.publish_date_start === "" ? "Present":item.publish_date_start.substring(0,10)}}&nbsp;
            <i
              class="fas fa-arrow-right"
            ></i>
            &nbsp;{{item.publish_date_end === "" ? "Present":item.publish_date_end.substring(0,10)}}
          </div>
        </template>
        <template v-slot:cell(created_at_date_only)="{ value, item }">
          <p class="mb-0">{{item.created_at_date_only}}</p>
          by {{item.created_by_username}}
        </template>
        <template v-slot:cell(updated_at_date_only)="{ value, item }">
          <div v-if="item.updated_at_date_only == ''">-</div>
          <div v-else>
            <p class="mb-0">{{item.updated_at_date_only}}</p>
            by {{item.updated_by_username}}
          </div>
        </template>
        <template v-slot:cell(image)="row">
          <b-img :src="row.value" width="70px" rounded alt="Image"></b-img>
        </template>
        <template v-slot:cell(status)="row">
          <p class="text-success" v-if="row.value == 'publish'">Publish</p>
          <p class="text-warning" v-else-if="row.value == 'archive'">Archive</p>
        </template>
        <template v-slot:cell(title.id)="row">
          <div v-html="row.value.substring(0,20)"></div>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{name: 'editShowCase', params: {id: item.id}}"
            class="text-dark"
          >
            <img src="@/assets/ic-edit.svg" class="mr-2" alt />
          </router-link>
          <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="del(item.id)">
            <img src="@/assets/rectangle.svg" alt />
          </b-link>
        </template>
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{rows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      errored: false,
      items: [],
      vuex: [],
      selected: [],
      key: [
        {
          key: 'selected',
          class: 'text-center',
        },
        {
          key: 'created_at_date_only',
          label: 'Created',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'image',
          label: 'Image',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'title.id',
          label: 'Title',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'publish_date',
          label: 'Publish Date',
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'updated_at_date_only',
          label: 'Updated',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          class: 'text-center',
        },
        { key: 'action', label: 'Action', class: 'text-center' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      customerShow: false,
      selected_field_true: true,
      selected_field_false: false,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    },
  },
  beforeCreate() {
    this.$store
      .dispatch('ShowCaseModule/getShowCases')
      .then((response) => {
        this.loading = false;
      })
      .catch((error) => {
        this.$swal({
          type: 'error',
          title: 'Oops...',
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.loading = false;
      });
  },
  created() {
    this.$store.watch(
      state => state.ShowCaseModule.showcase,
      (newValue, oldValue) => {
        this.items = newValue;
      },
    );
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    onRowSelected(items) {
      this.selected = items;
    },
    submitStatus(status) {
      this.$swal({
        title: 'Are you sure?',
        text: `You will ${status} this On Boarding Screen!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
        if (result.value) {
          const formData = new FormData();
          $.each(this.selected, (key, value) => {
            formData.append('showcase_id', value.id);
            formData.append('status', status);
          });
          $.each(formData.getAll('showcase_id'), (key, value) => {
            console.log(value);
          });

          this.loading = true;

          this.$store
            .dispatch('ShowCaseModule/updateShowCases', formData)
            .then((response) => {
              this.loading = false;
              this.$store.dispatch('ShowCaseModule/getShowCases', null, {
                root: true,
              });
              this.$swal({
                type: 'success',
                title: 'Your work has been saved',
                showConfirmButton: false,
                timer: 1000,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: 'error',
                title: 'Oops...',
                text: error.response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(error);
            });
        }
      });

      // console.log(list);
    },
    toggleAll(checked) {
      this.selected = checked
        ? this.$refs.selectableTable.selectAllRows()
        : this.$refs.selectableTable.clearSelected();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    del(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('ShowCaseModule/delShowCase', id);
          this.$swal('Deleted!', 'Your file has been deleted.', 'success');
        }
      });
    },
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (newVal.length === this.items.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
  },
};
</script>

<style>
</style>
